import axios from "axios";
import { decryptAES, encryptAES } from "./encrypt";
import { attachRetryInterceptor } from "./retryInterceptor";

// Create Axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_Gateway,
  headers: {
    "Content-Type": "application/json",
  },
});

// List of headers to encrypt
const headersToEncrypt = [
  "Password",
  "Userid",
  "Client-Code",
  "Partner-Code",
  "partnerCode",
  "partnercode",
  "PartnerCode",
  "ClientCode",
];
if(process.env.REACT_APP_IS_E_E === 'false')
{
  sessionStorage.setItem("decv",process.env.REACT_APP_GM_2);
  
  // Request interceptor without encryption when disabled
  api.interceptors.request.use(
    (config) => {
      // No encryption processing when disabled
      return config;
    },
    (error) => {
      console.error("Request Error:", error);
      return Promise.reject(error);
    }
  );

  // Response interceptor without decryption when disabled
  api.interceptors.response.use(
    (response) => {
      // No decryption processing when disabled
      return response;
    },
    (error) => {
      // No decryption processing when disabled
      return Promise.reject(error);
    }
  );
}
else
{

api.interceptors.request.use(
  (config) => {
    const isMultipart =
      config.headers["Content-Type"] &&
      config.headers["Content-Type"].includes("multipart/form-data");

    // Encrypt entire URL query string (everything after question mark)
    if (config.params && typeof config.params === 'object') {
      // Convert params object to URL search params string
      const urlParams = new URLSearchParams();
      for (const [key, value] of Object.entries(config.params)) {
        if (value !== null && value !== undefined) {
          urlParams.append(key, String(value));
        }
      }
      const queryString = urlParams.toString();
      
      if (queryString) {
        // Encrypt the entire query string and replace params with single encrypted parameter
        const encryptedQueryString = encryptAES(queryString);
        // URL encode the encrypted string to handle spaces and special characters
        const urlEncodedEncryptedString = encodeURIComponent(encryptedQueryString);
        config.params = { q: urlEncodedEncryptedString };
      }
    }

    // Encrypt body data if not multipart
    if (!isMultipart && config.data) {
      const encryptedData = encryptAES(config.data);
      config.data = encryptedData;
    }

    // Encrypt only allowed headers
    if (config.headers) {
      for (const header of headersToEncrypt) {
        if (config.headers[header]) {
          config.headers[header] = encryptAES(config.headers[header]);
        }
      }
    }

    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor for decryption and logging
api.interceptors.response.use(
  (response) => {
    if (response.data) {
      const decryptedData = decryptAES(response.data);
      response.data = decryptedData;
    }
    return response;
  },
  (error) => {
    if (error?.response?.data) {
      const decryptedData = decryptAES(error.response.data);
      error.response.data = decryptedData;
    }
    return Promise.reject(error);
  }
);
}

attachRetryInterceptor(api);

export default api;
